import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PublicHttpServiceInterface } from './public-http.service.interface';

@Injectable({
  providedIn: 'root',
})
export class PublicHttpService implements PublicHttpServiceInterface {
  private http = inject(HttpClient);

  public get<T>(url: string, params?: HttpParams): Observable<T> {
    return this.http.get<T>(url, { params });
  }

  public post<T>(url: string, body: any, params?: HttpParams): Observable<T> {
    return this.http.post<T>(url, body, { params });
  }

  public patch<T>(url: string, body: any, params?: HttpParams): Observable<T> {
    return this.http.patch<T>(url, body, { params });
  }

  public put<T>(url: string, body: any, params?: HttpParams): Observable<T> {
    return this.http.put<T>(url, body, { params });
  }

  public delete<T>(url: string, params?: HttpParams): Observable<T> {
    return this.http.delete<T>(url, { params });
  }
}
